module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "divbox"
    }
  }, [_c('div', {
    attrs: {
      "id": "number"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.displayNumber) + "\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b1fd3ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/TotalNumbers.vue
// module id = 2019
// module chunks = 0